import { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { Toaster, toast } from "react-hot-toast";

// @mui material components
import Grid from "@mui/material/Grid";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

import { IoCheckmarkSharp, IoCheckmarkDoneSharp } from "react-icons/io5";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiLabel from "components/VuiLabel";
import VuiInput from "components/VuiInput";
import VuiInputMask from "components/VuiInputMask";
import VuiSelect from "components/VuiSelect";
import VuiButtonCustom from "components/VuiButtonCustom";
import VuiCheckBox from "components/VuiCheckBox";

import Footer from "examples/Footer";

// Images
import Loading from "examples/Icons/Loading";

// Helper
import { validateCPF, validateEmail } from "helpers/utilities";

import useWindowDimensions from "hooks/useWindowDimensions";
import breakpoints from "assets/theme/base/breakpoints";

import colors from "assets/theme/base/colors";

import api, { backEndUrl, frontEndUrl, backImgUrl } from "services/api";

import { Container, Content, TextArea, FlexRow } from "./styles";

const idServiceOrder = uuidv4().split("-");

async function supportUsers(e) {
  // console.log(">>> supportUsers", e);

  const groups = await api.get(`groups`);
  // console.log(">>> groups", groups.data);
  // setLstGroupInit(groups.data);

  const arrayGroup = groups.data.map((i) =>
    i.values
      .split(",")
      .map((x) => x.trim())
      .includes(e.value)
  );

  const users = await api.get(`users/?group=${groups.data[arrayGroup.lastIndexOf(true)].id}`);

  const result = users.data.data.map((x) => {
    return { label: x.name, value: x.uuid, group: x.id_group };
  });

  console.log(">>> supportUsers", result);
  return result;
}

function VuiRow() {
  return <div style={{ height: 30 }}></div>;
}

function VuiContainer({ children }) {
  return <div style={{ marginTop: 10, width: "100%" }}>{children}</div>;
}

function LoadingServiceOrder() {
  const { height, width } = useWindowDimensions();
  return (
    <VuiBox sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Loading />
    </VuiBox>
  );
}

function FocusNextField(fieldName) {
  const nextfield = document.querySelector(`input[name=${fieldName}]`);
  nextfield.focus();
}

function IsCurrentBoss(office) {
  return (
    office.toUpperCase() === "GESTOR" ||
    office.toUpperCase() === "SUPERVISOR" ||
    office.toUpperCase() === "CHEFE"
  );
}

const notify = (message) =>
  toast.error(message, {
    style: {
      fontSize: 14,
      borderRadius: "5px",
      background: "#333",
      color: "#fff",
    },
  });

// const initStates = {
//   idOrderService: idServiceOrder[0] + "" + idServiceOrder[1] + "" + idServiceOrder[2],
//   dtOrderService: moment().format("DD/MM/YYYY HH:mm"),
//   user: "",
//   department: "",
//   typeService: {},
//   problemDescription: "",
//   newUserAD: "",
// };

const initStates = {
  idOrderService: idServiceOrder[0] + "" + idServiceOrder[1] + "" + idServiceOrder[2],
  dtOrderService: moment().format("DD/MM/YYYY HH:mm"),
  registry: "",
  user: "",
  department: "",
  typeService: {},
  gender: {},
  id_individual_register: "",
  email: "",
  phone: "",
  branch: "",
  problemDescription: "",
  newUserAD: "",
  assignCallTo: [],
  checkNumberSei: false,
  numberSei: "",
};

const initNewUserActiveDirectory = {
  registration: "",
  fullName: "",
  id_individual_register: "",
  loginName: "",
  eMail: "",
  personaleMail: "",
  departmentAcronym: "",
  phone: "",
  checkUserAccept: false,
};

const initTypeServiceSelect = {
  label: "",
  value: "",
  isBoss: false,
  placeholder: "",
};

const ACTION_PROTOCOL = 0;
const ACTION_TYPESERVICE = 1;
const ACTION_METHOD = 2;
const ACTION_ORIGI = 3;

function FormServiceOrder({ isMobile, onClose = () => {} }) {
  const userLogged = JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading] = useState(true);
  const [departmentSelected, setDepartmentSelected] = useState("");
  const [isDisabledText, setIsDisabledText] = useState(true);
  const [isDisabledSave, setIsDisabledSave] = useState(false);
  const [lstTypeService, setLstTypeService] = useState(null);
  const [typeServiceSelect, setTypeServiceSelect] = useState(initTypeServiceSelect);
  const [states, setStates] = useState(initStates);
  const [newUserActiveDirectory, setNewUserActiveDirectory] = useState(initNewUserActiveDirectory);
  const [lstAssignCallTo, setLstAssignCallTo] = useState([]);

  const { search } = useLocation();

  const actionCommand = search.replace("?", "").split("=")[0];
  const actionExec = search.replace("?", "").split("=")[1];

  async function searchRegister() {
    const value = states.registry;
    console.log(">>> states.registry:", value);

    if (value.length > 3) {
      let arrUserFound = { ...initStates };

      const res1 = await api.get(`users/?velti=${value}`);
      const dataUser = res1.data.data.length > 0 ? res1.data.data[0] : [];

      const res2 = await api.get(`velti/s?register=${value}`);
      const dataVelti = res2.data;

      // console.log(">>> users?velti ...............:", dataUser, typeof dataUser, dataUser.length);
      // console.log(">>> velti/s?register:dataVelti:", dataVelti);

      if (!dataVelti.found) {
        notify(`Matricula do colaborador VELTI não cadastrado...`);
        return null;
      }

      if (dataVelti.found) {
        // console.log(">>> dataUser: encontrado");
        // console.log(">>> dataVelti:", dataVelti);
        // console.log(">>> arrUserFound:", { ...dataVelti });
        // console.log(">>> lstDepartment:", { ...lstDepartment });
        arrUserFound = { ...dataVelti };
      }

      if (dataUser.gender === "") {
        const strGenderByName = dataVelti.name.split(" ")[0].slice(-1).toUpperCase();

        if (strGenderByName === "O") {
          dataUser.gender = "Masculino";
        } else if (strGenderByName === "A") {
          dataUser.gender = "Feminino";
        }
      }

      dataUser.branch = dataUser.branch ? dataUser.branch : "";

      setIndexGender(lstGender.findIndex((x) => x.value === dataUser.gender));

      setStates({ ...states, ...arrUserFound, ...dataUser, registry: value });
      // setIsDisabledInputs(false);
      // FocusNextField("id_individual_register");
    } else if (value.length === 0 || value === 0) {
      setStates(initStates);
    }
  }

  async function saveSupportCall() {
    // await searchRegister();

    const newOccurrence = {
      ...states,
      user: { ...userLogged, acronym: userLogged.acronym ? userLogged.acronym : "" },
      newUserAD: states.typeService.value === "NU" ? newUserActiveDirectory : "",
      typeService: { label: states.typeService.label, value: states.typeService.value },
      lstAssignCallTo: lstAssignCallTo,
      registry: userLogged.registration_velti,
      fullName: userLogged.name,
    };

    if (states.typeService.value !== "NU") {
      delete newOccurrence.newUserAD;
    }

    console.log(">>> newOccurrence", JSON.stringify(newOccurrence, null, 2));

    const res = await api.post(`occurrence/register`, newOccurrence, {
      headers: { "Content-Type": "application/json", authorization: userLogged.token },
    });

    if (res.data.data.client) {
      console.log(res);
    }
  }

  useEffect(() => {
    async function load() {
      setLoading(true);
      const res = await api.get(`velti/register/?register=${userLogged.registration_velti}`);

      const ACTION_EXEC = actionExec ? actionExec.split("&") : false;

      // console.log(">>> userLogged ..............:", userLogged);
      // console.log(">>> res.data.found ..........:", res.data.found);
      // console.log(">>> actionExec ..............:", actionExec);
      // console.log(">>> actionCommand ...........:", actionCommand);
      // console.log(">>>   ACTION_PROTOCOL .......:", ACTION_EXEC[ACTION_PROTOCOL]);
      // console.log(">>>   ACTION_TYPESERVICE ....:", ACTION_EXEC[ACTION_TYPESERVICE]);
      // console.log(">>>   ACTION_METHOD .........:", ACTION_EXEC[ACTION_METHOD]);
      // console.log(">>>   ACTION_ORIGI ..........:", ACTION_EXEC[ACTION_ORIGI]);

      userLogged.department = "";

      if (res.data.found) {
        let acronym = res.data.initials ? res.data.initials.trim() : "";
        res.data.initials = acronym;

        console.log(">>> res.data:", res.data);
        const departmentSelected = res.data.initials + " - " + res.data.department;
        const isCurrentBoss = IsCurrentBoss(res.data.office);
        console.log(">>> departmentSelected:", departmentSelected);

        setDepartmentSelected(departmentSelected);

        setStates({
          ...states,
          department: departmentSelected,
          departmentAcronym: departmentSelected,
          registry: userLogged.registration_velti,
          fullName: userLogged.name,
          acronym: acronym,
        });

        // setNewUserActiveDirectory({
        //   ...newUserActiveDirectory,
        // });

        // setStates({ ...states, department: departmentSelected });

        // if (ACTION_EXEC) {
        //   console.log(">>> actionCommand ...........:", actionCommand);
        //   console.log(">>>   ACTION_PROTOCOL .......:", ACTION_EXEC[ACTION_PROTOCOL]);
        //   console.log(">>>   ACTION_TYPESERVICE ....:", ACTION_EXEC[ACTION_TYPESERVICE]);
        //   console.log(">>>   ACTION_METHOD .........:", ACTION_EXEC[ACTION_METHOD]);
        //   console.log(">>>   ACTION_ORIGI ..........:", ACTION_EXEC[ACTION_ORIGI]);
        // }

        const supports = await api.get(`types/supports`);
        const newLstTypeService = [];

        supports.data.data.map(async (i) => {
          const item = {
            label: i.name,
            value: i.value,
            isBoss: i.isBoss,
            caption: i.caption,
            placeholder: i.placeholder,
          };

          if (ACTION_EXEC) {
            if (i.value === ACTION_EXEC[ACTION_TYPESERVICE]) {
              // console.log(
              //   ">>>   i.value ...............:",
              //   i.value,
              //   i.value === ACTION_EXEC[ACTION_TYPESERVICE],
              //   item.isBoss,
              //   isCurrentBoss
              // );
              newLstTypeService.push(item);

              const users = await supportUsers(item);
              setLstAssignCallTo(users);
            }
          } else {
            if (item.isBoss && isCurrentBoss) {
              newLstTypeService.push(item);
            }
            if (!item.isBoss) {
              newLstTypeService.push(item);
            }
          }
        });

        // console.log(">>> newLstTypeService:", newLstTypeService);

        setLstTypeService(newLstTypeService);

        // console.log(">>>   i.value ...............:", newLstTypeService.length);
        // console.log(">>>   i.value ...............:", newLstTypeService[0]);

        if (newLstTypeService.length === 1) {
          setStates({
            ...states,
            user: userLogged,
            department: departmentSelected,
            departmentAcronym: departmentSelected,
            registry: userLogged.registration_velti,
            typeService: newLstTypeService[0],
            fullName: userLogged.name,
            acronym: acronym,
          });

          setTypeServiceSelect(newLstTypeService[0]);
          setIsDisabledText(false);
        }
      }
      setLoading(false);
    }

    load();
  }, [false]);

  useEffect(() => {
    console.log(">>> states:", states);
    if (states.typeService.value === "AU") {
      if (states.problemDescription !== null) setIsDisabledSave(false);
    }
    if (states.typeService.value === "NU") {
      setIsDisabledSave(false);
    }
  }, [states]);

  if (isMobile) {
    // ########################################################################
    // Mobile View
    //
    return (
      <>
        {typeServiceSelect && typeServiceSelect.value !== "NU" && (
          <>
            <VuiContainer>
              <VuiLabel title="Abertura de Chamado de Suporte" sizeTitle={18} />
            </VuiContainer>
            <VuiRow />

            <VuiContainer>
              <VuiLabel title="Número da Ordem" />
              <VuiInput value={states.idOrderService} disabled />
            </VuiContainer>
            <VuiContainer>
              <VuiLabel title="Data de Abertura" />
              <VuiInput value={states.dtOrderService} disabled />
            </VuiContainer>
            <VuiContainer>
              <VuiLabel title="Requerente do Chamado" />
              <VuiInput
                placeholder="Informe a Contato/Responsável"
                value={userLogged.name}
                disabled
              />
            </VuiContainer>
            <VuiContainer>
              <VuiLabel title="Departamento" />
              <VuiInput value={states.department} disabled />
            </VuiContainer>
            <VuiContainer>
              {lstTypeService && lstTypeService.length > 1 ? (
                <VuiSelect
                  label="Tipo de Manutenção"
                  name={"selectTypeMaintenance"}
                  placeholder={isMobile ? "Escolha a Manutenção" : "Informe o Tipo de Manutenção"}
                  options={lstTypeService}
                  defaultValue={lstTypeService[0]}
                  onCustomChange={async (e) => {
                    console.log(">>> lstTypeService:", e);
                    setTypeServiceSelect(e);
                    setStates({
                      ...states,
                      typeService: e,
                    });

                    const groups = await api.get(`groups`);
                    // console.log(">>> groups", groups.data);
                    // setLstGroupInit(groups.data);

                    const arrayGroup = groups.data.map((i) =>
                      i.values
                        .split(",")
                        .map((x) => x.trim())
                        .includes(e.value)
                    );
                    const users = await supportUsers(e);
                    setLstAssignCallTo(users);
                  }}
                />
              ) : (
                <>
                  <VuiLabel title="Tipo de Manutenção" />
                  <VuiInput value={lstTypeService ? lstTypeService[0]?.label : ""} disabled />
                </>
              )}
            </VuiContainer>

            <VuiContainer>
              <VuiLabel title="Descrição do Problema:" />
              <TextArea
                disabled={isDisabledText}
                rows={8}
                multiline
                name="problemDescription"
                value={states.problemDescription}
                onChange={(e) => {
                  setStates({
                    ...states,
                    problemDescription: e.target.value,
                  });
                }}
                placeholder={
                  typeServiceSelect
                    ? typeServiceSelect.placeholder
                    : "Descreva aqui com todos os detalhes do problema"
                }
              />
            </VuiContainer>
          </>
        )}

        {/*  */}
        {typeServiceSelect && typeServiceSelect.value === "NU" && (
          <>
            <VuiContainer>
              <VuiLabel title="Nome Completo" />
              <VuiInput value={""} />
            </VuiContainer>
            <VuiContainer>
              <VuiLabel title="CPF" />
              <VuiInput value={""} />
            </VuiContainer>
            <VuiContainer>
              <VuiLabel title="Matricula" />
              <VuiInput value={""} />
            </VuiContainer>
            <VuiContainer>
              <VuiLabel title="E-mail Institucional" />
              <VuiInput value={""} />
            </VuiContainer>
          </>
        )}

        <VuiContainer>
          <div style={{ display: "flex", flexDirection: "row", paddingTop: 10 }}>
            <div style={{ width: "50%", paddingRight: 5 }}>
              <VuiButtonCustom
                title={"Fechar"}
                color="dark"
                fontWeight="bold"
                // disabled={isDisabledSave}
                onClick={() => {
                  onClose(true);
                }}
                style={{ width: 300 }}
              />
            </div>
            <div style={{ width: "50%", paddingLeft: 5 }}>
              <VuiButtonCustom
                title="Salvar"
                color="success"
                fontWeight="bold"
                // disabled={isDisabledSave}
                onClick={() => {
                  saveSupportCall();
                }}
              />
            </div>
          </div>
        </VuiContainer>
      </>
    );
  } else {
    // ########################################################################
    // Web View
    //
    return (
      <Grid container spacing={0}>
        <Grid item xs={12} lg={12} xl={12}>
          <VuiLabel title="Abertura de Chamado de Suporte" sizeTitle={32} />
          <VuiRow />

          <Grid container spacing={1}>
            {/*  */}
            {typeServiceSelect && typeServiceSelect.value !== "NU" && (
              <>
                <Grid item xs={12} lg={12} xl={4}>
                  <VuiLabel title="Número da Ordem" />
                  <VuiInput value={states.idOrderService} disabled />
                </Grid>
                <Grid item xs={12} lg={12} xl={4}>
                  <VuiLabel title="Data de Abertura" />
                  <VuiInput value={states.dtOrderService} disabled />
                </Grid>
                <Grid item xs={12} lg={12} xl={4} />

                {/*  */}
                <Grid item xs={12} lg={12} xl={4}>
                  <VuiLabel title="Requerente do Chamado" />
                  <VuiInput
                    placeholder="Informe a Contato/Responsável"
                    value={userLogged ? userLogged.name : ""}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} lg={12} xl={4}>
                  <VuiLabel title="Departamento" />
                  <VuiInput value={states.department} disabled />
                </Grid>

                {/*  */}
                <Grid item xs={12} lg={12} xl={4}>
                  <div style={{ width: isMobile ? "180%" : "100%" }}>
                    {lstTypeService && lstTypeService.length > 1 ? (
                      <VuiSelect
                        label="Tipo de Manutenção"
                        name={"selectTypeMaintenance"}
                        placeholder={
                          isMobile ? "Escolha a Manutenção" : "Informe o Tipo de Manutenção"
                        }
                        options={lstTypeService}
                        defaultValue={null}
                        onCustomChange={async (e) => {
                          console.log(">>> lstTypeService:", e);
                          setTypeServiceSelect(e);
                          setIsDisabledText(false);
                          setStates({
                            ...states,
                            typeService: e,
                          });

                          const users = await supportUsers(e);
                          setLstAssignCallTo(users);
                        }}
                      />
                    ) : (
                      <>
                        <VuiLabel title="Tipo de Manutenção" />
                        <VuiInput value={lstTypeService ? lstTypeService[0]?.label : ""} disabled />
                      </>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12} lg={12} xl={12}>
                  <VuiLabel title="Descrição do Problema:" />
                  <TextArea
                    disabled={isDisabledText}
                    rows={8}
                    multiline
                    name="problemDescription"
                    value={states.problemDescription}
                    onChange={(e) => {
                      setStates({
                        ...states,
                        problemDescription: e.target.value,
                      });
                    }}
                    placeholder={
                      typeServiceSelect
                        ? typeServiceSelect.placeholder
                        : "Descreva aqui com todos os detalhes do problema"
                    }
                  />
                </Grid>
              </>
            )}

            {/*  */}
            {typeServiceSelect && typeServiceSelect.value === "NU" && (
              <>
                <Grid item xs={12} lg={12} xl={12}>
                  <VuiLabel title="Novo Usuário de Domínio" sizeTitle={18} fontWeightTitle="bold" />
                </Grid>
                <Grid item xs={12} lg={12} xl={2}>
                  <VuiLabel title="Matrícula" />
                  <VuiInput
                    placeholder={`Informe a matricula ou deixe em branco`}
                    value={newUserActiveDirectory.registration}
                    onChange={async (e) => {
                      const value = e.target.value;

                      setNewUserActiveDirectory({
                        ...newUserActiveDirectory,
                        registration: value,
                      });

                      console.log(">>> value:length:", value.length);

                      if (value.length > 3) {
                        const res = await api.get(`users/s?boss=${value}`);
                        const dataVelti = res.data.data;

                        console.log(">>> dataVelti:", dataVelti);

                        if (dataVelti.found && !dataVelti.velti) {
                          notify(
                            `Usuário "${dataVelti.user.name.split(" ")[0]} ${
                              dataVelti.user.name.split(" ")[
                                dataVelti.user.name.split(" ").length - 1
                              ]
                            }" já cadastrad${
                              dataVelti.user.gender.substr(0, 1) === "M" ? "o" : "a"
                            }...`
                          );
                        } else if (!dataVelti.found && !dataVelti.velti) {
                          notify(`Usuário não encontrado no VELTI...`);
                          setNewUserActiveDirectory({
                            ...newUserActiveDirectory,
                            registration: value,
                            id_individual_register: "",
                            fullName: "",
                            loginName: "",
                            eMail: "",
                            personaleMail: "",
                          });
                        } else {
                          const loginName =
                            dataVelti.user.name.split(" ")[0].toLowerCase() +
                            "." +
                            dataVelti.user.name
                              .split(" ")
                              [dataVelti.user.name.split(" ").length - 1].toLowerCase()
                              .replace("ç", "c")
                              .replace(/[aáàãâä]/g, "a")
                              .replace(/[eéèêë]/g, "e")
                              .replace(/[iíìîï]/g, "i")
                              .replace(/[oóòõôö]/g, "o")
                              .replace(/[uúùûü]/g, "u");

                          setNewUserActiveDirectory({
                            ...newUserActiveDirectory,
                            registration: value,
                            id_individual_register: dataVelti.user.id_individual_register,
                            fullName: dataVelti.user.name,
                            loginName: loginName,
                            eMail: loginName + "@seap.ma.gov.br",
                            personaleMail: dataVelti.user.email,
                          });
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={12} xl={3}>
                  <VuiLabel title="CPF" />
                  <VuiInputMask
                    placeholder="Informe o CPF"
                    mask="cpf"
                    value={newUserActiveDirectory.id_individual_register}
                    onChange={async (e) => {
                      const value = e.target.value;
                      const lengthValue = value.replace(/\_|\.|\-/g, "").length;

                      setNewUserActiveDirectory({
                        ...newUserActiveDirectory,
                        id_individual_register: value,
                      });

                      if (lengthValue === 11) {
                        if (validateCPF(value.replace(/\_|\.|\-/g, ""))) {
                          const res = await api.get(`users/s?id_individual_register=${value}`);
                          const dataUser = res.data?.data || {};
                          const found = dataUser?.found || false;

                          if (found) {
                            notify(
                              `Usuário "${dataUser.name.split(" ")[0]} ${
                                dataUser.name.split(" ")[dataUser.name.split(" ").length - 1]
                              }" já cadastrad${dataUser.gender.substr(0, 1) === "M" ? "o" : "a"}...`
                            );
                          } else {
                            // FocusNextField("userName");
                            console.log(">>> true found");

                            //
                          }
                        } else {
                          notify(`Número de CPF "${value}" inválido`);
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={12} xl={7}>
                  <VuiLabel title="Nome Completo" />
                  <VuiInput value={newUserActiveDirectory.fullName} />
                </Grid>

                {/* <Grid item xs={12} lg={12} xl={4} />   */}
                <Grid item xs={12} lg={12} xl={3}>
                  <VuiLabel title="login:" />
                  <VuiInput value={newUserActiveDirectory.loginName} />
                </Grid>
                <Grid item xs={12} lg={12} xl={3}>
                  <VuiLabel title="E-mail Institucional" />
                  <VuiInput value={newUserActiveDirectory.eMail} disabled />
                </Grid>
                <Grid item xs={12} lg={12} xl={3}>
                  <VuiLabel title="E-mail pessoal" />
                  <VuiInput
                    value={newUserActiveDirectory.personaleMail}
                    onChange={(e) => {
                      console.log(">>> e", e.target.value);
                      const email = e.target.value;
                      // if (validateEmail(email)) {
                      setNewUserActiveDirectory({
                        ...newUserActiveDirectory,
                        personaleMail: email,
                      });
                      // }
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={12} xl={3}>
                  <VuiLabel title="Número do Celular Whatsapp" />
                  <VuiInputMask
                    name="phone"
                    placeholder="Informe o número do celular"
                    mask="phone"
                    value={newUserActiveDirectory?.phone}
                    onChange={(e) => {
                      setNewUserActiveDirectory({
                        ...newUserActiveDirectory,
                        phone: e.target.value,
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={12} xl={12}>
                  <VuiLabel
                    title="Sistemas que o colaborador terá acesso:"
                    sizeTitle={16}
                    fontWeightTitle="bold"
                  />
                </Grid>
                <Grid item xs={12} lg={12} xl={6}>
                  <FlexRow>
                    <IoCheckmarkSharp color={colors.online.main} size={18} />
                    <VuiLabel title={"Rede Unificada SEAP/Estado"} />
                  </FlexRow>
                  <FlexRow>
                    <IoCheckmarkSharp color={colors.online.main} size={18} />
                    <VuiLabel title={"Internet"} />
                  </FlexRow>
                  <FlexRow>
                    <IoCheckmarkSharp color={colors.online.main} size={18} />
                    <VuiLabel title={"Rede Wi-fi SEAP"} />
                  </FlexRow>
                </Grid>
                <Grid item xs={12} lg={12} xl={6}>
                  <FlexRow>
                    <IoCheckmarkSharp color={colors.online.main} size={18} />
                    <VuiLabel title={"Siisp"} />
                  </FlexRow>
                  <FlexRow>
                    <IoCheckmarkSharp color={colors.online.main} size={18} />
                    <VuiLabel title={"Velti"} />
                  </FlexRow>
                </Grid>

                <Grid item xs={12} lg={12} xl={12}></Grid>
                <Grid item xs={12} lg={12} xl={12}>
                  <VuiLabel
                    title="Termo de responsabilidade:"
                    sizeTitle={16}
                    fontWeightTitle="bold"
                  />
                  <VuiLabel title="" sizeTitle={2} sizeSubTitle={2} />
                  <VuiCheckBox
                    label={`EU, ${userLogged.name} colaborador(a) da Secretaria de Estado de Administração Penitenciária – SEAP, como responsável do departamento ${states.department}, certifico que todas as informações são verídicas e o novo cadastro será necessário para o desenvolvimentos dos trabalhos deste setor.`}
                    name="checkUserAccept"
                    value={newUserActiveDirectory.checkUserAccept}
                    onChange={() => {
                      console.log(">>> checkUserAccept:", newUserActiveDirectory.checkUserAccept);
                      setNewUserActiveDirectory({
                        ...newUserActiveDirectory,
                        checkUserAccept: !newUserActiveDirectory.checkUserAccept,
                      });
                    }}
                  />
                </Grid>
              </>
            )}

            {/*  */}
            <Grid item xs={12} lg={12} xl={12} />
            <Grid item xs={12} lg={12} xl={12} />
            <Grid item xs={12} lg={12} xl={12} />
            <Grid item xs={12} lg={12} xl={8} />
            <Grid item xs={12} lg={12} xl={2}>
              <VuiButtonCustom
                title={typeServiceSelect.value === "NU" ? "Cancelar" : "Fechar"}
                color="dark"
                fontWeight="bold"
                // disabled={isDisabledSave}
                onClick={() => {
                  if (typeServiceSelect.value === "NU") {
                    setTypeServiceSelect({
                      label: "",
                      value: "",
                      isBoss: false,
                      placeholder: "",
                    });
                  } else {
                    onClose(true);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} lg={12} xl={2}>
              <VuiButtonCustom
                title="Salvar"
                color="success"
                fontWeight="bold"
                disabled={isDisabledSave}
                onClick={() => {
                  saveSupportCall();
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

function ServiceOrder() {
  const { height, width } = useWindowDimensions();
  const [loading, setLoading] = useState(true);
  const [onClose, setOnClose] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);

  const history = useHistory();

  useEffect(() => {
    // A function that sets the display state for the DefaultNavbarMobile.
    function displayMobileNavbar() {
      if (window.innerWidth < breakpoints.values.lg) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }

    /** 
     The event listener that's calling the displayMobileNavbar function when 
     resizing the window.
    */
    window.addEventListener("resize", displayMobileNavbar);

    // Call the displayMobileNavbar function to set the state with the initial value.
    displayMobileNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", displayMobileNavbar);
  }, []);

  useEffect(() => {
    // console.log(">>> actionCommand:", actionCommand);
    // console.log(">>>    actionExec:", actionExec.split("&"));
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, [false]);

  useEffect(() => {
    if (onClose) {
      localStorage.clear();
      history.push("/login?redirect=/support");
    }
  }, [onClose]);

  return (
    <Container>
      <Toaster position="top-right" reverseOrder={false} />
      <Content width={isMobileView ? 90 : 60} p={isMobileView ? 0.5 : 2.25}>
        {loading ? (
          <LoadingServiceOrder />
        ) : (
          <FormServiceOrder
            isMobile={isMobileView}
            onClose={() => {
              setOnClose(true);
            }}
          />
        )}
      </Content>
      <Footer />
    </Container>
  );
}

export default ServiceOrder;
